import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import api from 'utils/api';
import { parseUserSearchInput } from './parseUserSearchInput';
export function fetchUserCount(_x) {
  return _fetchUserCount.apply(this, arguments);
}
function _fetchUserCount() {
  _fetchUserCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryObj) {
    var apiQuery, _yield$api, count;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiQuery = {
            count: true
          };
          parseUserSearchInput(queryObj.search, apiQuery);
          _context.next = 1;
          return api('get', '/api/query/users', apiQuery);
        case 1:
          _yield$api = _context.sent;
          count = _yield$api.count;
          return _context.abrupt("return", count);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchUserCount.apply(this, arguments);
}
export default fetchUserCount;